// extracted by mini-css-extract-plugin
export default {"Button":"_nnvDgIsNrcqQZYsEOhi2","ButtonInverse":"_1vXVkBmzpPWkb9eAG_BkoZ","ButtonDanger":"_2CRcrBP3ovalUijeQAoMTl"};